export const sortResourceItemsOfModules = (items, resourceOrder) => {
  const mutatedItems = [...items];

  if (!resourceOrder) {
    return mutatedItems.sort((a, b) => {
      const dateA = new Date(a.lastModified || a.last_modified || a.createdAt);
      const dateB = new Date(b.lastModified || b.last_modified || b.createdAt);
      return dateB.getTime() - dateA.getTime();
    });
  }

  return mutatedItems.sort((a, b) => {
    const indexA = resourceOrder.indexOf(a.id);
    const indexB = resourceOrder.indexOf(b.id);
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });
};
